module.exports = __webpack_public_path__ + "img/reguity-logo-white.de9db0e3.png";